<template>
  <div class="flex gap-4 items-center">
    <div
      class="border rounded-md px-2 py-1"
      :style="{ backgroundColor: finalBackgroundColor, borderColor: backgroundColor }"
    >
      {{ toProperCase(String(params.value)) }}
    </div>
  </div>
</template>

<script>
import {changeAlpha, toProperCase} from '@/utils/common';

export default {
  methods: {toProperCase},
  components: {},
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  computed: {
    backgroundColor() {
      // Use getBlockColor function if provided, otherwise use blockColor direct value
      if (this.params.getBlockColor && typeof this.params.getBlockColor === 'function') {
        return this.params.getBlockColor(this.params);
      }
      return this.params.blockColor || '#FFFFFF'; // Default fallback color
    },
    finalBackgroundColor(){
      if(this.backgroundColor){
        return changeAlpha(this.backgroundColor,0.3)
      }
      else{
        return 'FFFFFF'
      }
    }
  },

}
</script>

<style scoped>
/* Add any necessary styles here */
</style>
